import {
    GET_PARTY_REQUEST,
    GET_PARTY_SUCCESS,
    GET_PARTY_FAILURE,
    PARTY_LOGIN_REQUEST,
    PARTY_LOGIN_SUCCESS,
    PARTY_LOGIN_FAILURE,
    PARTY_LOGIN_DIRECTLY_REQUEST,
    PARTY_LOGIN_DIRECTLY_SUCCESS,
    PARTY_LOGIN_DIRECTLY_FAILURE,
    CHECK_JOINED_REQUEST,
    CHECK_JOINED_SUCCESS,
    CHECK_JOINED_FAILURE,
    GET_RECORDS_REQUEST,
    GET_RECORDS_SUCCESS,
    GET_RECORDS_FAILURE,
    UPLOAD_RECORD_REQUEST,
    UPLOAD_RECORD_SUCCESS,
    UPLOAD_RECORD_FAILURE,
    GET_LEADERBOARD_REQUEST,
    GET_LEADERBOARD_SUCCESS,
    GET_LEADERBOARD_FAILURE,
    GET_PARTY_RECORD_REQUEST,
    GET_PARTY_RECORD_SUCCESS,
    GET_PARTY_RECORD_FAILURE,
    SYNC_PROFILE_REQUEST,
    SYNC_PROFILE_SUCCESS,
    SYNC_PROFILE_FAILURE,
} from '../constant/actionTypes'

const initState = {
    partyInfo: {},
    partyNotExist: false,
    isCheckingFinish: false,
    checked: false,
    loginSuccess: false,
    isLoggingIn: false,
    hasUploaded: false,
    synchronizing: false,
    record: {},
    leaderboard: {
        noData: false,
        isGetting: false,
        list: [],
    },
    userRecord: {
        hasUploaded: false,
    },
}

const party = (state = initState, action) => {
    switch (action.type) {
        case GET_PARTY_SUCCESS:
            return {
                ...state,
                partyInfo: action.payload,
            }
        case GET_PARTY_FAILURE:
            return {
                ...state,
                partyNotExist: true,
            }
        case PARTY_LOGIN_REQUEST:
        case PARTY_LOGIN_DIRECTLY_REQUEST:
            return {
                ...state,
                isLoggingIn: true,
            }
        case PARTY_LOGIN_SUCCESS:
        case PARTY_LOGIN_DIRECTLY_SUCCESS:
            return {
                ...state,
                loginSuccess: true,
                isLoggingIn: false,
            }
        case PARTY_LOGIN_FAILURE:
        case PARTY_LOGIN_DIRECTLY_FAILURE:
            return {
                ...state,
                loginSuccess: false,
                isLoggingIn: false,
            }
        case CHECK_JOINED_REQUEST:
            return {
                ...state,
                isCheckingFinish: false,
            }
        case CHECK_JOINED_SUCCESS:
            return {
                ...state,
                isCheckingFinish: true,
                checked: action.payload.checked,
            }
        case CHECK_JOINED_FAILURE:
            return {
                ...state,
                isCheckingFinish: true,
            }
        case GET_RECORDS_SUCCESS:
            return {
                ...state,
                records: action.payload,
            }
        case GET_RECORDS_FAILURE:
            return {
                ...state,
                record: {}
            }
        case UPLOAD_RECORD_SUCCESS:
            return {
                ...state,
                hasUploaded: true,
            }
        case UPLOAD_RECORD_FAILURE:
            return {
                ...state,
                hasUploaded: false,
            }
        case GET_LEADERBOARD_REQUEST:
            {
                return {
                    ...state,
                    leaderboard: {
                        ...state.leaderboard,
                        isGetting: true,
                    },
                }
            }
        case GET_LEADERBOARD_SUCCESS:
            return {
                ...state,
                leaderboard: {
                    ...state.leaderboard,
                    ...action.payload,
                    isGetting: false,
                },
            }
        case GET_LEADERBOARD_FAILURE:
            return {
                ...state,
                leaderboard: {
                    noData: true,
                    isGetting: false,
                    list: [],
                },
            }
        case GET_PARTY_RECORD_SUCCESS:
            return {
                ...state,
                hasUploaded: action.payload.hasUploaded,
                userRecord: {
                    ...state.userRecord,
                    ...action.payload,
                }
            }
        case GET_PARTY_RECORD_FAILURE:
            return {
                ...state,
                userRecord: {
                    hasUploaded: false,
                }
            }
        case SYNC_PROFILE_REQUEST: {
            return {
                ...state,
                synchronizing: true,
            }
        }
        case SYNC_PROFILE_SUCCESS: {
            return {
                ...state,
                synchronizing: false,
                userRecord: {
                    ...state.userRecord,
                    name: action.payload.name,
                    avatar: action.payload.avatar,
                },
            }
        }
        case SYNC_PROFILE_FAILURE: {
            return {
                ...state,
                synchronizing: false,
            }
        }
        case GET_PARTY_REQUEST:
        case GET_RECORDS_REQUEST:
        case UPLOAD_RECORD_REQUEST:
        case GET_PARTY_RECORD_REQUEST:
        default:
            return {
                ...state,
            }
    }
}

export default party